module Meevo.Plugins.MerchantAccounts {
    "use strict";

    export class CareCreditSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.MerchantAccount> {
        private readonly hostedPageId: Meevo.Model.HostedPageIdType = 'HostedPageCareCreditAdmin';

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            identityService: Meevo.Components.Common.IIdentityService,
            noun: Meevo.Model.NounEnum,
            protected modalService: Components.Modal.IModalService,
            protected hostedPageService: Meevo.Components.HostedPage.IHostedPageService,
            sectionSecurityKey?: string,
        ) {
            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, identityService, noun, null, sectionSecurityKey);
            this.modalService = modalService;
        }

        selected(subSectionContentKey?: string): void {
            const merchantAccountId = this.parentItemId;

            this.dataService.customMethodData(`api/MerchantAccount/${merchantAccountId}`, "GET", null).then((response) => {
                const merchantAccount = response.data;
                this.showHostedPage(merchantAccount);
            });
        }

        private showHostedPage(merchantAccount) {
            this.hostedPageService.reset(this.hostedPageId);

            const request: Meevo.Components.HostedPage.IHostedPageRequest = {
                merchantAccountId: merchantAccount.id,
                merchantProviderId: merchantAccount.merchantProviderId,
                adminPage: "manage-promotions",
            };

            this.hostedPageService.process(request, this.hostedPageId)
                .then(() => {
                    this.showHostedPage(merchantAccount);
                })
                .catch((response: any) => {
                    if (response.status == 409) { // conflict
                        return this.modalService.alert(response.data.responseStatus.message);
                    }
                });
        }
    }
}